<template lang="pug">
.prize-purse-table
  table(v-for="table in tables")
    tbody
      tr
        th
          div Place
        th(v-if="table[0].percent")
          div % of Purse
        th
          div Final Payout
      tr(v-for="row in table")
        td {{row.place}}
        td(v-if="row.percent") {{row.percent.toFixed(2)}} %
        td
          Numberflip(
            :value="row.value"
            type="currency"
            currency="USD"
            :durationMs="350 + (row.value / rows[0].value) * 350 "
          )
</template>
<script lang="ts" setup>
import { computed } from 'vue'
import Numberflip from './numberflip.vue'

const props =  defineProps<{
  rows: {place: number, percent?: number, payout: string, value: number}[],
  max?: number
}>()

const tables = computed(() => [props.rows.slice(0, Math.ceil(props.rows.length / 2)), props.rows.slice(Math.ceil(props.rows.length / 2))])

</script>
<style lang="scss" scoped>
.prize-purse-table {
  display: flex;

  @include mobile() {
    display: block;
  }

  table {
    th {
      font-weight: $weight-bold;
      font-family: $font-header;
      font-size: $size-l;
      text-transform: uppercase;
    }

    td {
      font-size: $size-m;

      &:last-child {
        font-weight: $weight-bold;
      }
    }
  }
}</style>
